import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByDateTime'
})
export class SortByDateTime implements PipeTransform {
  transform(array: any[], propertyName: string): any[] {
    if (!Array.isArray(array) || array.length <= 1) {
        return array;
    }
    return array;
  }
}
